import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const handleEmergencyCall = () => {
    window.location.href = 'tel:0827935785';
  };

  return (
    <section className="relative bg-gradient-to-br from-primary via-secondary to-primary min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=1920')] bg-cover bg-center opacity-10"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 py-12 lg:py-20 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="text-white space-y-6 md:space-y-8">
            <div className="inline-flex items-center gap-2 bg-accent/20 backdrop-blur-sm px-4 py-2 rounded-full border border-accent/30">
              <Icon name="Award" size={20} color="var(--color-accent)" />
              <span className="text-sm md:text-base font-semibold text-accent">30+ Years of Proven Excellence</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-6xl font-bold leading-tight">
              Master Craftsman You Can Trust
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-gray-200 leading-relaxed">
              From emergency repairs to complex commercial installations, Gert van Rooyen delivers unmatched expertise backed by partnerships with McDonald's, KFC, and South Africa's leading brands.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={handleEmergencyCall}
                className="flex items-center justify-center gap-3 bg-accent hover:bg-accent/90 text-white px-6 md:px-8 py-4 md:py-5 rounded-lg font-bold text-base md:text-lg transition-all duration-300 emergency-cta shadow-elevated"
              >
                <Icon name="Phone" size={24} />
                <span>Emergency: 082 793 5785</span>
              </button>

              <Link to="/contact">
                <Button variant="outline" className="w-full sm:w-auto bg-white/10 backdrop-blur-sm border-white/30 text-white hover:bg-white/20 px-6 md:px-8 py-4 md:py-5 text-base md:text-lg">
                  Get Free Quote
                </Button>
              </Link>
            </div>

            <div className="grid grid-cols-3 gap-4 md:gap-6 pt-6 md:pt-8 border-t border-white/20">
              <div className="text-center">
                <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-accent">30+</div>
                <div className="text-xs md:text-sm text-gray-300 mt-1">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-accent">24/7</div>
                <div className="text-xs md:text-sm text-gray-300 mt-1">Emergency Service</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 md:p-8 border border-white/20 shadow-elevated">
              <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6">Quick Service Finder</h3>
              
              <div className="space-y-3 md:space-y-4">
                <Link to="/plumbing-services" className="block group">
                  <div className="bg-white/5 hover:bg-white/10 border border-white/20 rounded-lg p-4 md:p-5 transition-all duration-300">
                    <div className="flex items-center gap-3 md:gap-4">
                      <div className="bg-accent/20 p-3 rounded-lg">
                        <Icon name="Droplet" size={24} color="var(--color-accent)" />
                      </div>
                      <div className="flex-1">
                        <h4 className="text-base md:text-lg font-semibold text-white group-hover:text-accent transition-colors">Emergency Plumbing</h4>
                        <p className="text-xs md:text-sm text-gray-300">Leaks, burst pipes, repairs</p>
                      </div>
                      <Icon name="ChevronRight" size={20} color="white" className="opacity-50 group-hover:opacity-100 transition-opacity" />
                    </div>
                  </div>
                </Link>

                <Link to="/electrical-services" className="block group">
                  <div className="bg-white/5 hover:bg-white/10 border border-white/20 rounded-lg p-4 md:p-5 transition-all duration-300">
                    <div className="flex items-center gap-3 md:gap-4">
                      <div className="bg-accent/20 p-3 rounded-lg">
                        <Icon name="Zap" size={24} color="var(--color-accent)" />
                      </div>
                      <div className="flex-1">
                        <h4 className="text-base md:text-lg font-semibold text-white group-hover:text-accent transition-colors">Electrical Services</h4>
                        <p className="text-xs md:text-sm text-gray-300">Fault finding, diagnostics, repairs</p>
                      </div>
                      <Icon name="ChevronRight" size={20} color="white" className="opacity-50 group-hover:opacity-100 transition-opacity" />
                    </div>
                  </div>
                </Link>

                <Link to="/commercial-experience" className="block group">
                  <div className="bg-white/5 hover:bg-white/10 border border-white/20 rounded-lg p-4 md:p-5 transition-all duration-300">
                    <div className="flex items-center gap-3 md:gap-4">
                      <div className="bg-accent/20 p-3 rounded-lg">
                        <Icon name="Building2" size={24} color="var(--color-accent)" />
                      </div>
                      <div className="flex-1">
                        <h4 className="text-base md:text-lg font-semibold text-white group-hover:text-accent transition-colors">Commercial Projects</h4>
                        <p className="text-xs md:text-sm text-gray-300">Complex installations, maintenance</p>
                      </div>
                      <Icon name="ChevronRight" size={20} color="white" className="opacity-50 group-hover:opacity-100 transition-opacity" />
                    </div>
                  </div>
                </Link>
              </div>

              <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-white/20">
                <div className="flex items-center gap-3 text-white">
                  <Icon name="Clock" size={20} color="var(--color-accent)" />
                  <span className="text-sm md:text-base">Average response time: &lt;60 minutes</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;